query migratePosition($eth_address: String!, $market_id: String!, $position_id: String!, $signature: String!) {
    migratePosition(eth_address: $eth_address, market_id: $market_id, position_id: $position_id, signature: $signature)
}
